export default "__VITE_ASSET__BkJ1JjZ7__"